import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "./pages/Login";
import CadastroAluno from "./pages/CadastroAluno";
import ValidarAluno from "./pages/ValidarAluno";
import Main from "./pages/Main";
import Redacoes from "./pages/Redacoes";
import RedacoesUERJ from "./pages/RedacoesUERJ";
import CorrecaoIAHumano from "./pages/CorrecaoIAHumano";
import CorrecaoUERJ from "./pages/CorrecaoUERJ";
import VisualizarCorrecaoUERJ from "./pages/VisualizarCorrecaoUERJ";
import RedacaoCriar from "./pages/RedacaoCriar";
import UploadRedacoes from "./pages/UploadRedacoes";
import UploadRedacoesIA from "./pages/UploadRedacoesIA";
import UploadRedacoesUERJ from "./pages/UploadRedacoesUERJ";
import UploadRedacaoTeste from "./pages/Teste/Upload";
import CorrecaoTeste from "./pages/Teste/Correcao";
import FazerCorrecao from "./pages/FazerCorrecao";
import CheckRedacoes from "./pages/CheckRedacoes";
import CorrecaoIA from "./pages/CorrecaoIA";
import RedacaoPdf from "./pages/RedacaoPdf";
import Classes from "./pages/Classes";
import Classe from "./pages/Classe";
import Medias from "./pages/Medias";
import Temas from "./pages/Temas";
import Materiais from "./pages/Materiais";
import Material from "./pages/Material";
import Suporte from "./pages/Suporte";
import Usuarios from "./pages/Usuarios";
import Mentoria from "./pages/Mentoria";
import Monitores from "./pages/Monitores";
import ListaMentoria from "./pages/ListaMentoria";
import Atividades from "./pages/Atividades";
import Corretores from "./pages/Corretores";
import Competencias from "./pages/Competencias";
import MinhasRedacoes from "./pages/MinhasRedacoes";
import LandingPage from "./pages/LandingPage";
import EbookPage from "./pages/EbookPage";
import ZoomPage from "./pages/ZoomPage";
import Planos from "./pages/Teste/Planos";
import Obrigado from "./pages/Teste/Obrigado";
import MeusPagamentos from "./pages/MeusPagamentos";
import MeusEbooks from "./pages/MeusEbooks";
import ComprarEbooks from "./pages/ComprarEbooks";
import Relatorios from "./pages/Relatorios";
import CorrecaoIAResultado from "./pages/CorrecaoIAResultado";
import PlanosTemas from "./pages/PlanosTemas";
import AssinarContrato from "./pages/AssinarContrato";
import Contratos from "./pages/Contratos";
import AvisosEntrega from "./pages/AvisosEntrega";
import Produtividade from "./pages/Produtividade";

export const PrivateRoute = ({ component: Component, socket, ...rest }) => (
  <Route
    {...rest}
    render={(props) => <Component socket={socket} {...props} />}
  />
);

function Routes(props) {
  const { socket } = props;

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={LandingPage} />
        <Route path="/ebook" exact component={EbookPage} />
        <Route path="/planos-uerj" exact component={ZoomPage} />
        <Route path="/login" exact component={Login} />
        <Route path="/recadaopdf/:id/:pdf" exact component={RedacaoPdf} />
        <Route path="/novo-cadastro/:chave" exact component={CadastroAluno} />
        {/* Pública: o responsável não tem conta, o token da query string é a credencial */}
        <Route path="/assinar-contrato" exact component={AssinarContrato} />
        <PrivateRoute
          path="/validar/cadastro/:cpf"
          exact
          component={ValidarAluno}
        />
        <PrivateRoute path="/logado" component={Main} />
        <PrivateRoute
          path="/escrever/redacao/:id"
          exact
          component={RedacaoCriar}
        />
        <PrivateRoute path="/redacao/:id" exact component={UploadRedacoes} />
        <PrivateRoute 
        path="/enviar-redacao" 
        exact 
        component={UploadRedacoesIA} 
        />
        <PrivateRoute path="/upload-redacao-uerj/:id_redacao" exact component={UploadRedacoesUERJ} />
        <PrivateRoute exact path="/upload-redacao-teste" component={UploadRedacaoTeste} />
          <PrivateRoute exact path="/correcao-teste/resultado" component={CorrecaoTeste} />
        <PrivateRoute
          path="/corrigir/:redacao/:id"
          exact
          component={FazerCorrecao}
        />
        <PrivateRoute path="/correcao/:id" exact component={CheckRedacoes} />
        <PrivateRoute exact path="/correcao-ia/resultado" component={CorrecaoIAResultado} />
        <PrivateRoute path="/correcao-ia/:id" exact component={CorrecaoIA} />
        <PrivateRoute path="/redacoes" component={Redacoes} />
        <PrivateRoute path="/redacoes-uerj" component={RedacoesUERJ} />
        <PrivateRoute path="/correcao-ia-humano" component={CorrecaoIAHumano} />
        <PrivateRoute path="/correcao-uerj/:id" exact component={CorrecaoUERJ} />
        <PrivateRoute path="/visualizar-correcao-uerj/:id" exact component={VisualizarCorrecaoUERJ} />
        <PrivateRoute path="/minhas-redacoes" exact component={MinhasRedacoes} />
        <PrivateRoute path="/atividades" exact component={Atividades} />
        <PrivateRoute path="/atividades/:id" exact component={Atividades} />
        <PrivateRoute path="/minhaclasse/:id" component={Classe} />
        <PrivateRoute path="/medias" component={Medias} />
        <PrivateRoute path="/cadastro/:id" component={Classe} />
        <PrivateRoute path="/classe" component={Classes} />
        <PrivateRoute path="/temas" component={Temas} />
        <PrivateRoute path="/corretores" component={Corretores} />
        <PrivateRoute path="/material/:id" component={Material} />
        <PrivateRoute path="/materiais" component={Materiais} />
        <PrivateRoute path="/suporte" socket={socket} component={Suporte} />
        <PrivateRoute path="/usuarios" component={Usuarios} />
        <PrivateRoute path="/contratos" exact component={Contratos} />
        <PrivateRoute path="/avisos-entrega" exact component={AvisosEntrega} />
        <PrivateRoute path="/produtividade" exact component={Produtividade} />
        <PrivateRoute path="/competencias" component={Competencias} />
        <PrivateRoute path="/mentoria" socket={socket} component={Mentoria} />
        <PrivateRoute path="/monitores" component={Monitores} />
        <PrivateRoute path="/listamentoria"
          socket={socket}
          component={ListaMentoria}
        />
        <PrivateRoute path="/planos" exact component={Planos} />
        <PrivateRoute path="/obrigado" exact component={Obrigado} />
        <PrivateRoute path="/meus-pagamentos" exact component={MeusPagamentos} />
        <PrivateRoute path="/meus-ebooks" exact component={MeusEbooks} />
        <PrivateRoute path="/comprar-ebooks" exact component={ComprarEbooks} />
        <PrivateRoute path="/relatorios" exact component={Relatorios} />
        <PrivateRoute path="/admin/planos-temas" component={PlanosTemas} />
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;
